import styled from 'styled-components';
import Button from '~components/Button';

export const WhiteButton = styled(Button)`
  color: #6f84c1;
  background-color: white;
  border: 1px solid #6f84c1;
  padding: 17px 60px;

  &:hover,
  &:focus {
    color: white;
    background-color: #6f84c1;
  }
`;
